import React from "react";

const SearchIcon = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="23.578" height="23.582" viewBox="0 0 23.578 23.582">
        <path id="search-solid" d="M23.258,20.388,18.666,15.8a1.1,1.1,0,0,0-.783-.322h-.751a9.575,9.575,0,1,0-1.658,1.658v.751a1.1,1.1,0,0,0,.322.783l4.592,4.592a1.1,1.1,0,0,0,1.561,0l1.3-1.3A1.11,1.11,0,0,0,23.258,20.388ZM9.579,15.474a5.9,5.9,0,1,1,5.9-5.9A5.892,5.892,0,0,1,9.579,15.474Z" />
      </svg>

    </>
  );
};
export default SearchIcon;
